module.exports = __webpack_public_path__ + "static/media/humanLaptopDark.6cb562d1.svg";